import styled from 'styled-components';
import { Button } from '@usealloy/component-library';

export const StyledLink = styled.a`
  margin: 0;
`;

export const StyledButton = styled(Button)`
  && {
    background-color: transparent;
    border: 0;
    padding-left: 0;
  }
  &&:hover:not(:disabled) {
    background-color: transparent;
  }
`;
